import { callApi } from '../service'

export const paymenttypeService = {
    getAll
};

async function getAll() {
    return callApi('/BackOffice/PaymentType', 'GET')
        .then((result) => {
            if (result.responseCode === "00") {
                return result.data;
            } else {
                return [];
            }
        });
}